import React from 'react'
import '../App.css';
import ServerInfo from '../server.json'

class Ebook extends React.Component {

    state = {
        contentUrl: 'http://192.168.0.110:8080/dev/index_RequireJS_no-optimize.html?epub=../epub_content/',
        ipAddress: ServerInfo.ipAddress,
    }

    render() {
        return(
            <div style={this.style}>
                {/*<button onClick={() => this.props.onEpubClicked(this.props.id, this.props.category)} style={this.btnStyle}>
                <div style={this.imgContainer}>
                    <img style={this.imgStyle} src={this.getEpubCover()} alt='' />
                </div>                
                </button>*/}
                <button onClick={() => this.gotoViewEbook(this.props.id)} style={this.btnStyle}>
                <div style={this.imgContainer}>
                    <img style={this.imgStyle} src={this.getEpubCover()} alt='' />
                </div>                
                </button>
                <div style={this.titleStyle}>{this.props.title}</div>
                <div style={this.fontStyle}>{this.props.publisher}</div>
            </div>
        );
    }

    getEpubCover()
    {
        console.log(this.props.category)
        var epubFolder = this.props.category
        // change " " in epub folder to "_"
        for(var i = 0; i < epubFolder.length; i++)
        {
            epubFolder = epubFolder.replace(" ", "_");
        }
        return 'http://' + this.state.ipAddress + '/epub_content/' + epubFolder + '/' + this.props.id + '/cover.png'
        // return 'http://localhost:8080/file/content/image/' + this.props.image
    }

    gotoViewEbook = (bookId) =>
    {
        this.props.libraryProps.history.push('/ebookdetail/' + bookId)
    }

    // Don't need in here
    getEpubLink()
    {
        var link = this.props.id
        return 'http://192.168.0.110:8080/dev/index_RequireJS_no-optimize.html?epub=../epub_content/' + link + '&goto=epubcfi(/6/2!/4/2/2)'
    }

    // Styles
    style = {
        width: 160,
        height: 250,
        //backgroundColor: 'lightgrey',
        padding: 10,
    }

    imgContainer = {
        width: 160,
        height: 212.61,
        margin: 0,
        backgroundColor: 'white',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: 'grey'
        
    }

    imgStyle = {
        width: 160,
        height: 212.61
    }

    imgStyleHide = {
        width: 160,
        display: 'none'
    }

    titleStyle = {
        marginLeft: 5,
        marginBottom: 2,
        marginTop: 5,
        fontWeight: 500,
        overflow: 'hidden',
        //display: '-webkit-box',
        //webkitLineClamp: 2,
        //webkitBoxOrient: 'vertical',
    }

    fontStyle = {
        marginLeft: 5,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: 12,
    }

    btnStyle = {
        background: 'none',
        border: 'none',
        padding: 0,
        margin: 0,
        cursor: 'pointer'
    }
}

export default Ebook